import defaultWebsiteData from '../configs/defaultWebsiteData';
import getInitialSortType from './getInitialSortType';
import { normalizeUserSrc } from '../../../store/helpers/teammates';
import CONSTANTS from '../../../shared/constants';

const { PASSWORD_STARS } = CONSTANTS;

const normalizeWebsiteSettings = ({
  websiteData, collectionData, team, isNewWebsite = false, userSortingCustomFields = [],
}) => {
  let copyWebsiteData = { ...websiteData };
  const isRetina = window.devicePixelRatio > 1;

  if (isNewWebsite) {
    copyWebsiteData = {
      ...defaultWebsiteData,
      alias: copyWebsiteData.suggestions.alias,
    };
  } else {
    copyWebsiteData = {
      ...defaultWebsiteData,
      ...copyWebsiteData,
    };
  }

  if (copyWebsiteData.isProtected) {
    copyWebsiteData.password = PASSWORD_STARS;
  }

  if (typeof copyWebsiteData.googleAnalyticsIdentifier !== 'string') {
    copyWebsiteData.googleAnalyticsIdentifier = '';
  }

  if (typeof copyWebsiteData.logoUrl !== 'string') {
    copyWebsiteData.logoUrl = '';
  }

  if (typeof copyWebsiteData.avatarUrl !== 'string') {
    copyWebsiteData.avatarUrl = '';
  }

  if (typeof copyWebsiteData.backgroundLoginPageUrl !== 'string') {
    copyWebsiteData.backgroundLoginPageUrl = '';
  }

  if (copyWebsiteData?.logoUrl) {
    copyWebsiteData.logoUrl = normalizeUserSrc(copyWebsiteData.logoUrl, 'large', isRetina);
  }

  if (copyWebsiteData?.avatarUrl) {
    copyWebsiteData.avatarUrl = normalizeUserSrc(copyWebsiteData.avatarUrl, 'large', isRetina);
  }

  if (copyWebsiteData?.thumbnailUrl) {
    copyWebsiteData.thumbnailUrl = normalizeUserSrc(copyWebsiteData.thumbnailUrl, 'large', isRetina);
  }

  if (isNewWebsite) {
    copyWebsiteData.sortType = getInitialSortType(collectionData.sortType, copyWebsiteData.sortType);
    copyWebsiteData.overridedDisplayName = team.displayName;
    copyWebsiteData.overridedTagname = collectionData.name;
    copyWebsiteData.customGalleryTitle = collectionData.name;
  }

  if (copyWebsiteData.sortType.type.startsWith('meta.') && !copyWebsiteData.customFieldsSort) {
    copyWebsiteData.customFieldsSort = userSortingCustomFields.filter((customField) => `meta.${customField.title}` === copyWebsiteData.sortType.type);
  }

  return copyWebsiteData;
};

export default normalizeWebsiteSettings;
